(function () {
  var MOUNT_CLASS = 'ha-account-rewards-mount';
  var YOTPO_INSTANCE_ID = '1330685';
  var YOTPO_LOADER_URL =
    'https://cdn-widgetsrepository.yotpo.com/v1/loader/W8pc8iY7liEnAE4uW577LxsofcRyBlJ1GCdZNP8X';
  var booted = false;
  var injectTimer = null;

  function getTemplateHtml() {
    var template = document.getElementById('ha-account-referral-template');
    if (template && template.innerHTML.trim()) {
      return template.innerHTML;
    }

    return (
      '<div class="ha-rewards-hero"><div class="ha-rewards-hero__widget">' +
      '<div class="yotpo-widget-instance" data-yotpo-instance-id="' +
      YOTPO_INSTANCE_ID +
      '"></div></div></div>'
    );
  }

  function navMatchesReferral(node) {
    if (!node) return false;
    var text = (node.textContent || '').toLowerCase();
    var route = (
      node.getAttribute('data-to') ||
      node.getAttribute('href') ||
      node.getAttribute('data-route') ||
      ''
    ).toLowerCase();
    return /referral|rewards|parrain|refer/.test(text + ' ' + route);
  }

  function viewMatchesReferral(view) {
    if (!view) return false;

    if (view.classList.contains('frcp-custom-page')) return true;

    var title = view.querySelector('.frcp-section__title');
    if (title && /referral|rewards|parrain/i.test(title.textContent || '')) {
      return true;
    }

    return false;
  }

  function isReferralView(app) {
    if (!app) return false;

    var hash = (window.location.hash || '').toLowerCase();
    if (/referral|rewards|refer/.test(hash)) return true;

    var activeNav = app.querySelector('.frcp-nav-button[active="true"], .frcp-nav-button--active');
    if (navMatchesReferral(activeNav)) return true;

    var activeView = getActiveMainView(app);
    return viewMatchesReferral(activeView);
  }

  function isVisible(node) {
    if (!node) return false;
    if (node.offsetParent !== null) return true;
    var rects = node.getClientRects();
    return rects && rects.length > 0;
  }

  function getActiveMainView(app) {
    var views = app.querySelectorAll('.frcp-main-view');
    for (var i = 0; i < views.length; i += 1) {
      if (isVisible(views[i])) return views[i];
    }
    return app.querySelector('.frcp-main-view');
  }

  function getMountParent(app) {
    if (!isReferralView(app)) return null;

    var activeView = getActiveMainView(app);
    if (!activeView) return null;

    var selectors = [
      '.frcp-custom-page__body',
      '.frcp-section__content',
      '.frcp-referral',
      '.frcp-loyalty',
    ];

    for (var i = 0; i < selectors.length; i += 1) {
      var node = activeView.querySelector(selectors[i]);
      if (node) return node;
    }

    return activeView;
  }

  function ensureYotpoLoader() {
    if (document.querySelector('script[src*="' + YOTPO_LOADER_URL + '"]')) {
      return;
    }

    var script = document.createElement('script');
    script.src = YOTPO_LOADER_URL;
    script.async = true;
    (document.head || document.documentElement).appendChild(script);
  }

  function initYotpoWidgets(scope, attempt) {
    attempt = attempt || 0;
    if (!scope) return;

    ensureYotpoLoader();

    var instances = scope.querySelectorAll('.yotpo-widget-instance[data-yotpo-instance-id]');
    if (!instances.length) return;

    var container = window.yotpoWidgetsContainer;
    if (container) {
      if (typeof container.initWidget === 'function') {
        instances.forEach(function (node) {
          container.initWidget(node);
        });
        return;
      }
      if (typeof container.initWidgets === 'function') {
        container.initWidgets();
        return;
      }
    }

    if (attempt < 40) {
      window.setTimeout(function () {
        initYotpoWidgets(scope, attempt + 1);
      }, 250);
    }
  }

  function ensureMount(app, parent) {
    var mount = app.querySelector('.' + MOUNT_CLASS);

    if (mount && mount.parentElement !== parent) {
      mount.remove();
      mount = null;
    }

    if (!mount) {
      mount = document.createElement('div');
      mount.className = MOUNT_CLASS;
      parent.appendChild(mount);
    }

    return mount;
  }

  function injectRewards(app) {
    if (!app || !isReferralView(app)) return;

    var parent = getMountParent(app);
    if (!parent) return;

    var mount = ensureMount(app, parent);
    mount.innerHTML = getTemplateHtml();
    mount.hidden = false;
    mount.style.display = 'block';
    initYotpoWidgets(mount);
  }

  function scheduleInject(app) {
    if (!app) return;
    window.clearTimeout(injectTimer);
    injectTimer = window.setTimeout(function () {
      injectRewards(app);
    }, 50);
  }

  function bindApp(app) {
    scheduleInject(app);

    app.addEventListener('click', function (event) {
      if (event.target.closest('.frcp-nav-button, .frcp-nav__menu a, [data-route], [data-to]')) {
        window.setTimeout(function () {
          scheduleInject(app);
        }, 80);
        window.setTimeout(function () {
          scheduleInject(app);
        }, 300);
        window.setTimeout(function () {
          scheduleInject(app);
        }, 900);
      }
    });

    var observer = new MutationObserver(function () {
      scheduleInject(app);
    });

    observer.observe(app, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['active', 'class', 'style'],
    });
  }

  function boot() {
    var app = document.querySelector('.frcp-app');
    if (!app) return false;

    if (!booted) {
      booted = true;
      bindApp(app);
    }

    scheduleInject(app);
    return true;
  }

  function waitForApp() {
    if (boot()) return;

    var tries = 0;
    var interval = window.setInterval(function () {
      tries += 1;
      if (boot() || tries >= 80) {
        window.clearInterval(interval);
      }
    }, 250);
  }

  document.addEventListener('frcp:loaded', waitForApp);
  document.addEventListener('frcp.navigation.mounted', waitForApp);
  document.addEventListener('frcp.customPage.mounted', waitForApp);
  document.addEventListener('DOMContentLoaded', waitForApp);
  window.addEventListener('hashchange', waitForApp);
})();
